<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
          <v-card-title class="ui-evaluation-card-title header-verde">
            <div class="text-subtitle-1 font-weight-bold">Observaciones</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    class="ui-form-field"
                    label="Ingrese observaciones"
                    v-model="evaluacion.detalle.observaciones"
                    rounded
                    filled
                    dense
                    color="secondary"
                    background-color="transparent"
                    no-resize
                    rows="3"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
          <v-card-title class="ui-evaluation-card-title header-verde">
            <div class="text-subtitle-1 font-weight-bold">Resultados</div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex ui-result-row">
                  <span>Resultado:</span>
                  <v-spacer></v-spacer>
                  <span class="font-weight-bold">
                    {{ RESULTADOS[getResultado] }}
                  </span>
                </v-col>
                <v-col cols="12" class="d-flex ui-result-row"
                  ><span>Puntaje total:</span>
                  <v-spacer />
                  <span class="font-weight-bold">{{ getPuntajeTotal }}</span>
                </v-col>
                <v-col cols="12" class="d-flex ui-result-row"
                  ><span>Calificación:</span>
                  <v-spacer></v-spacer>
                  <span class="font-weight-bold">{{ getCalificacion }}</span>
                </v-col>
                <v-col cols="12">
                  <BaseSelect v-model="evaluacion.detalle.status" label="Estatus" :items="estatusEvaluacionItems" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  getCalification,
  getIdResultado,
  getPuntajeTotal,
  RESULTADOS,
} from '../../../../modules/evaluacion-desempeño-academico/domain/rules/evaluation.rules'
import BaseSelect from '../../../base/BaseSelect.vue'

export default {
  components: { BaseSelect },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },

  async mounted() {
    await this.fetchEstatusEvaluacion()
  },

  data() {
    return {
      RESULTADOS,
    }
  },

  computed: {
    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacionItems: 'getEstatusEvaluacion',
    }),

    getResultado: function () {
      return getIdResultado(this.getPuntajeTotal, this.evaluacion.tipo)
    },

    getPuntajeTotal: function () {
      return getPuntajeTotal(this.evaluacion.reactivos)
    },

    getCalificacion: function () {
      return getCalification(this.getPuntajeTotal, this.evaluacion.tipo)
    },
  },

  methods: {
    ...mapActions('estatusEvaluacion', ['fetchEstatusEvaluacion']),
  },
}
</script>

<style scoped>
.ui-evaluation-card-title {
  color: #e0e0e0 !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
}

.header-verde {
  background: rgba(38, 222, 129, 0.15) !important;
  color: #26de81 !important;
  border-bottom: 1px solid rgba(38, 222, 129, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field textarea {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

.ui-result-row {
  color: #e0e0e0 !important;
}
</style>
